export default __webpack_public_path__ + "static/media/fl-mobile.a7171307.png";